import * as React from 'react';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { PersonaMeetingResponse, PersonaSize } from 'fabric-persona';
import { SIZE_TO_PIXELS } from './PersonaConsts';
import determineMeetingResponseIcon from '../utils/determineMeetingResponseIcon';

const styles = require('./Persona.scss');
const classNames = require('classnames/bind').bind(styles);

export interface PersonaMeetingResponseBadgeProps {
    personaSize: PersonaSize;
    meetingResponse: PersonaMeetingResponse;
}

const personaSizeFontScaleFactor = 3;
const personaResponseStatusLeftRightScaleFactor = 1.5;
const meetingResponseBadgeSizes = {};

/**
 * An indicator on the attendee persona representing whether the meeting has been accepted or declined
 */
export default class PersonaMeetingResponseBadge extends React.Component<
    PersonaMeetingResponseBadgeProps,
    {}
> {
    render() {
        const { meetingResponse } = this.props;
        const personaSize = SIZE_TO_PIXELS[this.props.personaSize];

        if (
            meetingResponse === undefined ||
            meetingResponse === null ||
            meetingResponse === PersonaMeetingResponse.Unknown
        ) {
            return null;
        }

        const badgeSizes = _getMeetingResponseBadgeSizes(personaSize);
        const personaSizeWithResponseIconStyle = {
            fontSize: badgeSizes.responseFontSize,
        };

        return (
            <i
                className={classNames(
                    'mini-Icon',
                    getIconClassName(
                        determineMeetingResponseIcon(
                            this.props.meetingResponse,
                            true /** isSolid */
                        )
                    ),
                    styles.personaResponseStatus,
                    {
                        accept: meetingResponse === PersonaMeetingResponse.Accept,
                        decline: meetingResponse === PersonaMeetingResponse.Decline,
                        tentative: meetingResponse === PersonaMeetingResponse.Tentative,
                    }
                )}
                style={personaSizeWithResponseIconStyle}
            />
        );
    }
}

function _getMeetingResponseBadgeSizes(personaSize: number) {
    let badgeSizes = meetingResponseBadgeSizes[personaSize];
    if (!badgeSizes) {
        meetingResponseBadgeSizes[personaSize] = {
            responseLeftRight: personaSize / personaResponseStatusLeftRightScaleFactor + 'px',
            responseFontSize: personaSize / personaSizeFontScaleFactor + 'px',
        };
        badgeSizes = meetingResponseBadgeSizes[personaSize];
    }
    return badgeSizes;
}
